import Rellax from 'rellax';

// Initialize Rellax on elements with the class "rellax"
const rellax = new Rellax('.rellax');


const rellaxImg = new Rellax('.rellax-img', {
    wrapper: '.ss-hero__image-wrapper'
});


// Stop Bootstrap dropdowns van automatisch activeren
document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-bs-toggle="dropdown"]').forEach(el => {
        el.removeAttribute('data-bs-toggle'); // voorkomt init
    });
});

document.addEventListener("DOMContentLoaded", function () {


    AOS.init({
        delay: 100,
        duration: 500,
    });

    var swiper = new Swiper('.swiper-deelnemers', {
        // Swiper options
        spaceBetween: 8,
        slidesPerView: "auto",
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        navigation: {
            nextEl: '#deelnemersNext',
            prevEl: '#deelnemersPrev',
        },
    });

    var swiper = new Swiper('.swiper-related-cards', {
        // Swiper options
        spaceBetween: 8,
        slidesPerView: "auto",
        // pagination: {
        //     el: '.swiper-pagination',
        //     clickable: true,
        // },
        navigation: {
            nextEl: '#relatedNext',
            prevEl: '#relatedPrev',
        },
    });
    document.querySelectorAll('.js-swiper').forEach(function (el) {
    // Nav-knoppen zoeken binnen hetzelfde blok (geen IDs nodig)
    var scope = el.closest('.related-activities') || document;
    var nextBtn = scope.querySelector('.js-next');
    var prevBtn = scope.querySelector('.js-prev');

    // Simpel, zoals je had – maar “scoped”
    new Swiper(el, {
      spaceBetween: 8,
      slidesPerView: 'auto',
      grabCursor: true,
      navigation: { nextEl: nextBtn, prevEl: prevBtn },
    //   pagination: { el: el.querySelector('.swiper-pagination'), clickable: true },
      // Robuuster tegen theme-CSS en DOM-mutaties:
      observer: true,
      observeParents: true,
      touchStartPreventDefault: false
    });
  });

    var swiper = new Swiper('.swiper-vacature-cards', {
        // Swiper options
        spaceBetween: 8,
        slidesPerView: "auto",
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        navigation: {
            nextEl: '#vacaturesNext',
            prevEl: '#vacaturesPrev',
        },
    });

    var swiper = new Swiper('.swiper-related-posts-cards', {
        // Swiper options
        spaceBetween: 8,
        slidesPerView: "auto",
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        navigation: {
            nextEl: '#relatedPostsNext',
            prevEl: '#relatedPostsPrev',
        },
    });

    var swiper = new Swiper('.swiper-cover-cards', {
        // Swiper options
        spaceBetween: 8,
        slidesPerView: "auto",
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        navigation: {
            nextEl: '#coverCardNext',
            prevEl: '#coverCardPrev',
        },
    });

});

// document.addEventListener('DOMContentLoaded', () => {
//     if (typeof Swiper === 'undefined') return;

//     // 1) initialize text swiper
//     const textSwiper = new Swiper('.js-text-swiper', {
//         effect: 'fade',
//         autoplay: {
//             delay: 10000, // Delay between transitions in ms
//             disableOnInteraction: false,
//         },
//         fadeEffect: { crossFade: true },
//         loop: false,
//         speed: 600,
//         allowTouchMove: false,
//         navigation: {
//             nextEl: '#testimonialNext',
//             prevEl: '#testimonialPrev',
//         },
//     });

//     // grab DOM elements
//     const wrapper = document.querySelector('.testimonials-images .images-wrapper');
//     const slides = Array.from(wrapper.children);
//     const prevBtn = document.getElementById('testimonialPrev');
//     const nextBtn = document.getElementById('testimonialNext');
//     const currentEl = document.getElementById('current-slide');
//     const totalEl = document.getElementById('total-slides');

//     const totalSlides = slides.length;
//     totalEl.textContent = String(totalSlides).padStart(2, '0');

//     // calculate slide width+gap once
//     const gap = 8;
//     const slideW = slides[0].getBoundingClientRect().width;
//     const step = slideW + gap;

//     function updateCarousel() {
//         const idx = textSwiper.activeIndex;

//         // 1) translate so that slide #idx is in the first slot
//         wrapper.style.transform = `translateX(-${idx * step}px)`;

//         // 2) highlight only the active image
//         slides.forEach((s, i) => {
//             s.classList.toggle('active', i === idx);
//         });

//         // 3) update pagination
//         currentEl.textContent = String(idx + 1).padStart(2, '0');

//         // 4) disable nav at ends
//         prevBtn.classList.toggle('swiper-button-disabled', textSwiper.isBeginning);
//         nextBtn.classList.toggle('swiper-button-disabled', textSwiper.isEnd);
//     }

//     textSwiper.on('init slideChange', updateCarousel);
//     textSwiper.init();

// });

document.addEventListener('DOMContentLoaded', () => {
    if (typeof Swiper === 'undefined') return;

    // ES-module build: you would have done Swiper.use([...]) above

    const textSwiper = new Swiper('.js-text-swiper', {
        effect: 'fade',
        fadeEffect: { crossFade: true },

        loop: true,
        autoplay: false,      // ensure autoplay is off

        speed: 600,
        allowTouchMove: false,

        navigation: {
            nextEl: '#testimonialNext',
            prevEl: '#testimonialPrev',
        },
    });

    const wrapper = document.querySelector('.testimonials-images .images-wrapper');
    const slides = Array.from(wrapper.children);
    const prevBtn = document.getElementById('testimonialPrev');
    const nextBtn = document.getElementById('testimonialNext');
    const currentEl = document.getElementById('current-slide');
    const totalEl = document.getElementById('total-slides');

    totalEl.textContent = String(slides.length).padStart(2, '0');

    const gap = 8;
    const slideW = slides[0].getBoundingClientRect().width;
    const step = slideW + gap;

    function updateCarousel() {
        const idx = textSwiper.realIndex; // ← use realIndex when loop:true
        wrapper.style.transform = `translateX(-${idx * step}px)`;
        slides.forEach((s, i) => s.classList.toggle('active', i === idx));
        currentEl.textContent = String(idx + 1).padStart(2, '0');
        // omit disabling logic in loop mode if you want infinite nav
    }

    textSwiper.on('init slideChange', updateCarousel);
    textSwiper.init();
});














jQuery(document).ready(function ($) {

    // Delegated event binding for dynamic elements.
    // 1) klik op het hart-icoon
    $(document).on("click", ".wishlist-icon", function (e) {
        e.preventDefault();

        var icon = $(this);
        var productId = icon.data("product-id");

        if (!productId) {
            console.warn('Geen product-id gevonden op wishlist-icon');
            return;
        }

        // 2) stuur AJAX naar hoofdsite
        $.post(wishlist_ajax.ajax_url, {
            action: "toggle_wishlist",
            product_id: productId,
            // optioneel: nonce: wishlist_ajax.nonce
        })
            .done(function (response) {
                // 3) werk teller bij (response.wishlist_count)
                $(".wishlist-count, .wishlist-header-count").text(response.wishlist_count);

                // 4) update icon-status
                if (response.status === "added") {
                    icon.addClass("in-wishlist");
                } else {
                    icon.removeClass("in-wishlist");
                }
            })
            .fail(function (jqXHR, textStatus, errorThrown) {
                console.error('Wishlist AJAX error:', textStatus, errorThrown);
            });
    });

    // Function to refresh the recent wishlist block via AJAX.
    function updateRecentWishlist() {
        $.ajax({
            url: wishlist_ajax.ajax_url,
            type: "POST",
            data: { action: "get_recent_wishlist" },
            success: function (response) {
                // If no wishlist items remain, hide the container.
                if (parseInt(response.wishlist_count, 10) === 0 || !$.trim(response.html)) {
                    $(".company-recent-wishlist").fadeOut(300);
                } else {
                    // Replace the existing block with the updated HTML.
                    $(".company-recent-wishlist").replaceWith(response.html);
                }
            }
        });
    }
});
















document.addEventListener('DOMContentLoaded', function () {
    var heroSwiper = new Swiper('.ss-hero-slider', {
        slidesPerView: 1,
        loop: true, // Set to false if you don't need looping
        autoplay: {
            delay: 7000, // Delay between transitions in ms
            disableOnInteraction: false,
        },
        effect: "fade",
        fadeEffect: { crossFade: true },
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
            type: 'bullets'
        }
    });
});


// ── YouTube Video Component ──────────────────────────────────────────
(function () {
    'use strict';

    var ytAPIReady = false;
    var ytAPILoading = false;
    var ytReadyCallbacks = [];
    var bgPlayers = {};
    var modalPlayer = null;

    function loadYTAPI() {
        if (ytAPIReady || ytAPILoading) return;
        ytAPILoading = true;
        var tag = document.createElement('script');
        tag.src = 'https://www.youtube.com/iframe_api';
        var first = document.getElementsByTagName('script')[0];
        first.parentNode.insertBefore(tag, first);
    }

    window.onYouTubeIframeAPIReady = function () {
        ytAPIReady = true;
        ytReadyCallbacks.forEach(function (cb) { cb(); });
        ytReadyCallbacks = [];
    };

    function onYTReady(cb) {
        if (ytAPIReady) { cb(); } else { ytReadyCallbacks.push(cb); }
    }

    function initBgPlayers() {
        var previews = document.querySelectorAll('.ss-youtube__preview[data-youtube-id]');
        if (!previews.length) return;
        loadYTAPI();

        previews.forEach(function (preview) {
            var videoId = preview.getAttribute('data-youtube-id');
            var container = preview.querySelector('.ss-youtube__bg-player');
            if (!container || !videoId) return;

            onYTReady(function () {
                var player = new YT.Player(container, {
                    videoId: videoId,
                    playerVars: {
                        autoplay: 1,
                        mute: 1,
                        controls: 0,
                        showinfo: 0,
                        rel: 0,
                        loop: 1,
                        playlist: videoId,
                        modestbranding: 1,
                        playsinline: 1,
                        disablekb: 1,
                        fs: 0,
                        iv_load_policy: 3,
                        origin: window.location.origin
                    },
                    events: {
                        onReady: function (e) {
                            e.target.mute();
                            e.target.playVideo();
                            // Hide poster once playing
                            var poster = preview.querySelector('.ss-youtube__poster');
                            if (poster) {
                                setTimeout(function () {
                                    poster.classList.add('is-hidden');
                                }, 800);
                            }
                        }
                    }
                });
                bgPlayers[videoId] = player;
            });
        });
    }

    function openModal(videoId) {
        var modal = document.getElementById('ss-youtube-modal');
        var playerContainer = document.getElementById('ss-youtube-modal-player');
        if (!modal || !playerContainer) return;

        // Clear previous player
        playerContainer.innerHTML = '';

        modal.classList.add('is-active');
        modal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';

        onYTReady(function () {
            modalPlayer = new YT.Player(playerContainer, {
                videoId: videoId,
                width: '100%',
                height: '100%',
                playerVars: {
                    autoplay: 1,
                    rel: 0,
                    modestbranding: 1,
                    playsinline: 1,
                    origin: window.location.origin
                }
            });
        });
    }

    function closeModal() {
        var modal = document.getElementById('ss-youtube-modal');
        if (!modal) return;

        modal.classList.remove('is-active');
        modal.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';

        if (modalPlayer && typeof modalPlayer.destroy === 'function') {
            modalPlayer.destroy();
            modalPlayer = null;
        }
        var playerContainer = document.getElementById('ss-youtube-modal-player');
        if (playerContainer) playerContainer.innerHTML = '';
    }

    document.addEventListener('DOMContentLoaded', function () {
        // Initialize background auto-playing previews
        initBgPlayers();

        // Play buttons (both in youtube_video and media components)
        document.addEventListener('click', function (e) {
            var btn = e.target.closest('.ss-youtube__play-btn, .ss-media__play-btn');
            if (!btn) return;
            e.preventDefault();

            var videoId = btn.getAttribute('data-youtube-id');
            if (!videoId) {
                // Try parent container
                var container = btn.closest('[data-youtube-id]');
                if (container) videoId = container.getAttribute('data-youtube-id');
            }
            if (videoId) {
                loadYTAPI();
                openModal(videoId);
            }
        });

        // Close modal
        document.addEventListener('click', function (e) {
            if (e.target.closest('.ss-youtube-modal__close') || e.target.closest('.ss-youtube-modal__backdrop')) {
                closeModal();
            }
        });

        // ESC key
        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape') closeModal();
        });

        // Media component YouTube items (click on poster to open popup)
        document.addEventListener('click', function (e) {
            var ytItem = e.target.closest('.ss-media__youtube');
            if (!ytItem) return;
            // Don't trigger if play button was clicked (already handled above)
            if (e.target.closest('.ss-media__play-btn')) return;

            var videoId = ytItem.getAttribute('data-youtube-id');
            if (videoId) {
                loadYTAPI();
                openModal(videoId);
            }
        });
    });
})();

jQuery(document).ready(function ($) {

    // Utility functions for cookies
    function getCookie(name) {
        var dc = document.cookie;
        var prefix = name + "=";
        var begin = dc.indexOf("; " + prefix);
        if (begin === -1) {
            begin = dc.indexOf(prefix);
            if (begin !== 0) return null;
        } else {
            begin += 2;
        }
        var end = document.cookie.indexOf(";", begin);
        if (end === -1) {
            end = dc.length;
        }
        return decodeURIComponent(dc.substring(begin + prefix.length, end));
    }

    function setCookie(name, value, days) {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + encodeURIComponent(value) + expires + "; path=/";
    }

    // Get wishlist from cookie (stored as JSON)
    function getWishlist() {
        var wishlist = getCookie('wishlist');
        if (wishlist) {
            try {
                return JSON.parse(wishlist);
            } catch (e) {
                return [];
            }
        }
        return [];
    }

    // Save wishlist array to cookie (set to expire in 30 days)
    function saveWishlist(wishlist) {
        setCookie('wishlist', JSON.stringify(wishlist), 30);
    }

    // Function to update the wishlist counter in the header
    function updateWishlistCount() {
        var wishlist = getWishlist();
        $('.wishlist-count').text(wishlist.length);
    }

    // Check if the current page is the favorites page by looking for a unique body class.
    function isFavoritesPage() {
        return $('body').hasClass('page-template-favorieten');
    }

    // Function to show a Bootstrap 5 notification alert at the top of the page.
    function showWishlistNotification(message) {
        var $notif = $("#wishlist-notification");
        if (!$notif.length) {
            $notif = $('<div id="wishlist-notification" class="position-fixed start-50 translate-middle-x p-3"></div>');
            $("body").append($notif);
        }
        // Create the Bootstrap alert element.
        var $alert = $(
            '<div class="alert alert-info fade show" role="alert">' +
            message +
            '</div>'
        );
        $notif.html($alert);
        // Auto-dismiss the alert
        setTimeout(function () {
            $alert.alert('close');
        }, 2000);
    }

    // On page load, mark wishlist items as added and update the text and counter.
    var wishlist = getWishlist();
    wishlist.forEach(function (postId) {
        $('.add-to-wishlist[data-post-id="' + postId + '"]').each(function () {
            $(this).addClass('added');
            $(this).find('.wishlist-text').text('In favorieten');
        });
    });
    updateWishlistCount();

    // Toggle wishlist item on click.
    $('.add-to-wishlist').on('click', function (e) {
        e.preventDefault();

        var postId = $(this).data('post-id');
        if (!postId) {
            console.log("No post ID found on this wishlist element.");
            return;
        }

        var wishlist = getWishlist();
        var index = wishlist.indexOf(postId);

        if (index === -1) {
            // Not in wishlist – add it.
            wishlist.push(postId);
            $(this).addClass('added');
            $(this).find('.wishlist-text').text('In favorieten');
            showWishlistNotification("Item toegevoegd aan favorieten.");
        } else {
            // Already in wishlist – remove it.
            wishlist.splice(index, 1);
            $(this).removeClass('added');
            $(this).find('.wishlist-text').text('Maak favoriet');
            showWishlistNotification("Item verwijderd uit favorieten.");

            // Only remove the card from the DOM if we're on the favorites page.
            if (isFavoritesPage()) {
                var $card = $(this).closest('.related-card, .agenda-card');
                if ($card.length) {
                    $card.fadeOut(300, function () {
                        $(this).remove();
                        if ($('.related-card, .agenda-card').length === 0) {
                            if (!$('.favorites-empty').length) {
                                $('.wrapper').append('<p class="favorites-empty text-center v-space-xx-lg">Er zijn nog geen favorieten toegevoegd.</p>');
                            }
                        }
                    });
                }
            }
        }

        saveWishlist(wishlist);
        updateWishlistCount();
    });
});

jQuery(document).ready(function ($) {
    function checkManualFiltersOverflow() {
        var $filters = $('.manual-filters');

        if ($filters.length) {
            // Er is minstens één .manual-filters element
            if ($filters[0].scrollWidth > $filters.outerWidth()) {
                $filters.addClass('can-scroll');
            } else {
                $filters.removeClass('can-scroll');
            }
        }
    }

    // Run check on load and on window resize.
    checkManualFiltersOverflow();
    $(window).resize(checkManualFiltersOverflow);
});



jQuery(function ($) {
    const ajaxUrl = wishlist_ajax.ajax_url;
    const $grid = $('#agendaContainer');
    const $pager = $('#agendaPagination');
    const params = new URL(window.location).searchParams;
    let pagina = parseInt(params.get('pagina'), 10) || 1;

    // 0) Helper: URL param wijzigen zonder reload
    function updateUrl(key, val) {
        const u = new URL(window.location);
        if (val != null && val !== '') u.searchParams.set(key, val);
        else u.searchParams.delete(key);
        history.replaceState(null, '', u);
    }

    // 1) AJAX-loader met fade-out/in & URL-sync
    function loadAgenda(p) {
        // 1a) fade-out bestaande items
        $grid.fadeTo(200, 0, () => {
            // 1b) vraag nieuwe data op
            $.post(ajaxUrl, {
                action: 'filter_agenda',
                doelgroep: $('#filterDoelgroep').val(),
                activiteitstype: $('#filterActiviteitstype').val(),
                locatie: $('#filterLocatie').val(),
                search: $('#agendaSearch').val(),
                paged: p
            }, function (res) {
                if (!res.success) return;
                // 1c) inject HTML & fade-in
                $grid.html(res.data.html).fadeTo(200, 1);
                $pager.html(res.data.pagination);
                // 1d) werk pagina-state en URL bij
                pagina = p;
                updateUrl('pagina', p);
            }, 'json');
        });
    }

    // 2) Filter handlers: altijd pagina terug naar 1
    $('#filterDoelgroep').on('change', function () {
        updateUrl('doelgroep', $(this).val());
        updateUrl('pagina', 1);
        loadAgenda(1);
    });
    $('#filterActiviteitstype').on('change', function () {
        updateUrl('activiteitstype', $(this).val());
        updateUrl('pagina', 1);
        // mirror manual-filters visueel
        $('.manual-filter').removeClass('active');
        $('.manual-filter[data-activiteitstype="' + $(this).val() + '"]').addClass('active');
        loadAgenda(1);
    });
    $('#filterLocatie').on('change', function () {
        updateUrl('locatie', $(this).val());
        updateUrl('pagina', 1);
        loadAgenda(1);
    });
    $('#agendaSearch').on('keyup change', function () {
        updateUrl('search', $(this).val());
        updateUrl('pagina', 1);
        loadAgenda(1);
    });

    // 3) Manual filter buttons
    $('.manual-filter').on('click', function (e) {
        e.preventDefault();
        // reset alle andere selects/search
        $('#filterDoelgroep, #filterLocatie').prop('selectedIndex', 0);
        $('#agendaSearch').val('');
        updateUrl('doelgroep', null);
        updateUrl('locatie', null);
        updateUrl('search', null);

        // zet activiteitstype
        const v = $(this).data('activiteitstype');
        $('#filterActiviteitstype').val(v);
        updateUrl('activiteitstype', v);

        // visuele state
        $('.manual-filter').removeClass('active');
        $(this).addClass('active');

        updateUrl('pagina', 1);
        loadAgenda(1);
    });

    // 4) Reset-knop
    $('#resetFilters').on('click', function (e) {
        e.preventDefault();
        $('#filterDoelgroep, #filterActiviteitstype, #filterLocatie').prop('selectedIndex', 0);
        $('#agendaSearch').val('');
        $('.manual-filter').removeClass('active');
        ['doelgroep', 'activiteitstype', 'locatie', 'search'].forEach(k => updateUrl(k, null));
        updateUrl('pagina', 1);
        loadAgenda(1);
    });

    // 5) Paginatie-clicks (delegated)
    $pager.on('click', 'a', function (e) {
        e.preventDefault();
        const m = this.href.match(/[?&]pagina=(\d+)/);
        loadAgenda(m ? parseInt(m[1], 10) : 1);
    });

    // 6) Init op paginaload: prefill & eventueel direct AJAX
    (function () {
        let need = false;
        // prefill selects/search vanuit URL
        ['doelgroep', 'activiteitstype', 'locatie', 'search'].forEach(k => {
            const v = params.get(k);
            if (v) {
                $('#filter' + k.charAt(0).toUpperCase() + k.slice(1)).val(v);
                need = true;
            }
        });
        if (pagina > 1) need = true;
        if (need) loadAgenda(pagina);
    })();
});






/* Verhalen */
jQuery(function ($) {
    if (!$('#verhalenGrid').length) return;
    const ajaxUrl = wishlist_ajax.ajax_url;
    const $grid = $('#verhalenGrid');
    const $pager = $('.posts-pagination');
    const params = new URL(window.location).searchParams;
    let page = parseInt(params.get('pagina') || params.get('paged'), 10) || 1;

    // Helper: update query-param zonder reload (strip WP /page/X/)
    function updateUrlParam(key, value) {
        const basePath = window.location.pathname.replace(/\/page\/\d+\/?$/, '/');
        const url = new URL(window.location.origin + basePath);
        window.location.search
            .slice(1).split('&')
            .filter(p => p && !p.startsWith(key + '='))
            .forEach(p => {
                const [k, v] = p.split('=');
                url.searchParams.set(k, v);
            });
        if (value != null && value !== '') url.searchParams.set(key, value);
        else url.searchParams.delete(key);
        history.replaceState(null, '', url);
    }

    // AJAX-loader met fadeTo(…) flow
    function loadVerhalen(p) {
        // fade uit naar opacity 0
        $grid.fadeTo(200, 0, () => {
            $.post(ajaxUrl, {
                action: 'filter_verhalen',
                categorie: $('#filterCategorie').val(),
                doelgroep: $('#filterDoelgroep').val(),
                rol: $('#filterRol').val(),
                paged: p
            }, res => {
                if (!res.success) return;
                // inject en fade terug naar 1
                $grid
                    .html(res.data.html)
                    .fadeTo(200, 1);
                $pager.html(res.data.pagination);
                page = p;
                // alleen pagina-param bij >1
                if (p > 1) updateUrlParam('pagina', p);
                else updateUrlParam('pagina', null);
            }, 'json');
        });
    }

    // Filter-change
    $('#filterCategorie, #filterDoelgroep, #filterRol').on('change', function () {
        page = 1;
        updateUrlParam('categorie', $('#filterCategorie').val());
        updateUrlParam('doelgroep', $('#filterDoelgroep').val());
        updateUrlParam('rol', $('#filterRol').val());
        updateUrlParam('pagina', null);
        loadVerhalen(1);
    });

    // Reset-knop
    $('#resetVerhalenFilters').on('click', function (e) {
        e.preventDefault();
        $('#filterCategorie, #filterDoelgroep, #filterRol').prop('selectedIndex', 0);
        updateUrlParam('categorie', null);
        updateUrlParam('doelgroep', null);
        updateUrlParam('rol', null);
        updateUrlParam('pagina', null);
        loadVerhalen(1);
    });

    // Delegate paginatie-clicks
    $pager.on('click', 'a', function (e) {
        e.preventDefault();
        const href = $(this).attr('href');
        let m = href.match(/[?&](?:pagina|paged)=(\d+)/);
        let next = m ? parseInt(m[1], 10) : 1;
        if (!m) {
            const m2 = href.match(/\/page\/(\d+)/);
            if (m2) next = parseInt(m2[1], 10);
        }
        loadVerhalen(next);
    });

    // Init on paginaload: prefill & (indien nodig) AJAX
    (function () {
        const initCat = params.get('categorie') || '',
            initDoel = params.get('doelgroep') || '',
            initRol = params.get('rol') || '';
        if (initCat) $('#filterCategorie').val(initCat);
        if (initDoel) $('#filterDoelgroep').val(initDoel);
        if (initRol) $('#filterRol').val(initRol);
        if (page > 1 || initCat || initDoel || initRol) {
            // fadeTo direct naar 0, daarna inject & fadeTo(1)
            loadVerhalen(page);
        }
    })();
});







// document.addEventListener('DOMContentLoaded', () => {
//     const rows = document.querySelectorAll('.foto-raster .gallery-row');
//     rows.forEach(row => {
//       const scrollDist = row.scrollWidth - row.clientWidth;
//       // if there’s nothing to scroll, default to 0
//       row.style.setProperty('--scroll-dist', `${scrollDist > 0 ? scrollDist : 0}px`);
//     });

//     // Optional: recalc on resize
//     window.addEventListener('resize', () => {
//       rows.forEach(row => {
//         const sd = row.scrollWidth - row.clientWidth;
//         row.style.setProperty('--scroll-dist', `${sd > 0 ? sd : 0}px`);
//       });
//     });
//   });



jQuery(function ($) {

    const $grid = $('#teamledenGrid');
    const $btn = $('#loadMoreTeamlid');
    const $gradient = $('.teamleden-gradient');
    const $loadWrap = $('.teamleden-loadmore-wrap');
    const ajaxUrl = $grid.data('ajax-url');
    let page = parseInt($grid.data('page'));
    const maxPage = parseInt($grid.data('max-page'));

    function loadPage(nextPage, replace = false) {
        const perPage = 12;
        const functie = $('#filterTeamlidFunctie').val();

        $.post(ajaxUrl, {
            action: 'load_more_teamleden',
            page: nextPage,
            functie: functie
        }, function (res) {
            if (replace) {
                $grid.html(res.html);
                page = 1;
            } else {
                $grid.append(res.html);
                page = nextPage;
            }

            // originele hebben-Meer logica
            if (!res.haveMore) {
                $loadWrap.addClass('hidden');
                $gradient.closest('.section-teamleden__grid-wrapper').addClass('finished');
            } else {
                $loadWrap.removeClass('hidden');
                $gradient.closest('.section-teamleden__grid-wrapper').removeClass('finished');
            }

            // **Nieuwe override voor filters**: als we repalcen en er < perPage items zijn, verberg de knop sowieso
            if (replace) {
                const totalLoaded = $grid.children('.section-teamleden__grid-item').length;
                if (totalLoaded < perPage) {
                    $loadWrap.addClass('hidden');
                    $gradient.closest('.section-teamleden__grid-wrapper').addClass('finished');
                }
            }

            // animatie fade-in
            $(res.html ? '.section-teamleden__grid-item' : [])
                .css('opacity', 0)
                .animate({ opacity: 1 }, 500);
        });
    }


    // Toon meer klik
    $btn.on('click', function (e) {
        e.preventDefault();
        if (page < maxPage) loadPage(page + 1);
    });

    // Filter change
    $('#filterTeamlidFunctie').on('change', function () {
        page = 1;
        loadPage(1, true);
    });
});


/*  nieuwsberichten */
jQuery(function ($) {
    // als we niet op de nieuws-pagina zitten (dus geen #filterCategory aanwezig), stop
    if (!$('#filterCategory').length) {
        return;
    }

    const ajaxUrl = wishlist_ajax.ajax_url;
    const $grid = $('#postsContainer');
    const $pager = $('#paginationContainer');
    const params = new URL(window.location).searchParams;
    let page = parseInt(params.get('pagina'), 10) || 1;

    // ─── Helper: URL-param zetten/verwijderen zonder reload
    function updateUrl(key, val) {
        const u = new URL(window.location);
        if (val != null && val !== '') u.searchParams.set(key, val);
        else u.searchParams.delete(key);
        history.replaceState(null, '', u);
    }

    // ─── AJAX-loader met fade-out → inject → fade-in
    function loadPosts(p) {
        $grid.add($pager).fadeTo(200, 0, () => {
            $.post(ajaxUrl, {
                action: 'filter_posts',
                category: $('#filterCategory').val(),
                paged: p,
                posts_per_page: wishlist_ajax.posts_per_page,
                nonce: wishlist_ajax.nonce
            }, function (res) {
                if (!res.success) return;
                $grid.html(res.data.posts);
                $pager.html(res.data.pagination);
                page = p;
                if (p > 1) updateUrl('pagina', p);
                else updateUrl('pagina', null);
                $grid.add($pager).fadeTo(200, 1);
            }, 'json');
        });
    }

    // ─── Filter-change
    $('#filterCategory').on('change', function () {
        page = 1;
        updateUrl('categorie', $(this).val());
        updateUrl('pagina', 1);
        loadPosts(1);
    });

    // ─── Reset-knop
    $('#resetPostFilters').on('click', function (e) {
        e.preventDefault();
        $('#filterCategory').prop('selectedIndex', 0);
        updateUrl('categorie', null);
        updateUrl('pagina', 1);
        loadPosts(1);
    });

    // ─── Pagina-clicks
    $pager.on('click', 'a', function (e) {
        e.preventDefault();
        const m = this.href.match(/[?&]pagina=(\d+)/);
        loadPosts(m ? parseInt(m[1], 10) : 1);
    });

    // ─── Init: vervang de statische paginering altijd meteen via AJAX
    (function () {
        const initCat = params.get('categorie') || '';
        if (initCat) $('#filterCategory').val(initCat);
        loadPosts(page);
    })();
});










// Teller animatie (ongeveer 2 seconden)
document.addEventListener('DOMContentLoaded', function () {
    var counters = document.querySelectorAll('.fotocollage-counter .number');
    if (!counters.length) return;

    counters.forEach(function (counter) {
        // animatiefunctie
        function animate() {
            var target = +counter.getAttribute('data-target');
            var count = 0;
            var frames = 120;
            var step = target / frames;

            function update() {
                count += step;
                if (count < target) {
                    counter.innerText = Math.ceil(count);
                    requestAnimationFrame(update);
                } else {
                    counter.innerText = target;
                }
            }
            update();
        }

        // observer voor dit specifieke counter-element
        var observer = new IntersectionObserver(function (entries, obs) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    animate();
                    obs.unobserve(entry.target);
                }
            });
        }, { threshold: 0.5 });

        // start observer op dit element
        observer.observe(counter);
    });

});


document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll('.gform_wrapper input[type="file"]').forEach(function (fileInput) {
        const wrapper = document.createElement('label');
        wrapper.className = 'custom-file-upload';
        const labelText = document.createElement('span');
        labelText.textContent = 'Kies bestand';
        const icon = document.createElement('div');
        icon.className = 'icon';
        icon.innerHTML = '&#xe927;';

        fileInput.parentNode.insertBefore(wrapper, fileInput);
        wrapper.appendChild(labelText);
        wrapper.appendChild(icon);
        wrapper.appendChild(fileInput);
    });
});






document.addEventListener('DOMContentLoaded', () => {

    const dropdownMenus = document.querySelectorAll('.header-nav > ul > li');
    if (window.innerWidth >= 992) {
        dropdownMenus.forEach((menuItem) => {
            const dropdown = menuItem.querySelector('.dropdown-menu');

            if (dropdown) { // ✅ Only apply logic if there's a dropdown inside
                menuItem.addEventListener('mouseenter', () => {
                    document.body.classList.add('dropdown-is-active');
                });

                menuItem.addEventListener('mouseleave', () => {
                    // Wait a bit to ensure the user isn't hovering another dropdown
                    setTimeout(() => {
                        if (!document.querySelector('.header-nav > ul > li:hover .dropdown-menu')) {
                            document.body.classList.remove('dropdown-is-active');
                        }
                    }, 100);
                });
            }
        });
    }
});



document.addEventListener('DOMContentLoaded', function () {
    const MOBILE_BREAK = 992;

    // ─── A) Hamburger (main menu) toggle ──────────────────────────────────────────
    const menuToggle = document.getElementById('menu-toggle-wrapper');
    const headerNav = document.getElementById('header-navigation');
    const headerWrap = document.querySelector('.header-wrapper');
    const placeholder = document.querySelector('.header-placeholder');
    const siteHeader = document.querySelector('.site-header');
    const actieBanner = document.querySelector('.actie-banner');
    let scrollPos = 0, lastScroll = window.scrollY;

    function refreshHeader() {
        const hh = headerWrap.offsetHeight;
        placeholder.style.height = hh + 'px';
        const bannerH = actieBanner ? actieBanner.offsetHeight : 0;
        const total = siteHeader.offsetHeight + bannerH;
        document.documentElement.style.setProperty('--total-header-height', total + 'px');
    }
    window.addEventListener('resize', refreshHeader);
    refreshHeader();

    menuToggle.addEventListener('click', function (e) {
        e.preventDefault();
        const open = this.getAttribute('aria-expanded') === 'true';
        this.setAttribute('aria-expanded', String(!open));
        this.classList.toggle('active', !open);

        if (!open) {
            headerNav.style.display = 'block';
            headerNav.style.opacity = '0';
            requestAnimationFrame(() => headerNav.style.opacity = '1');
            scrollPos = window.scrollY;
            document.body.classList.add('no-scroll');
            document.body.style.top = `-${scrollPos}px`;
        } else {
            headerNav.style.opacity = '0';
            headerNav.addEventListener('transitionend', () => {
                headerNav.style.display = 'none';
            }, { once: true });
            document.body.classList.remove('no-scroll');
            document.body.style.top = '';
            window.scrollTo(0, scrollPos);
        }
    });

    window.addEventListener('scroll', () => {
        const st = window.scrollY;
        const menuOpen = menuToggle.getAttribute('aria-expanded') === 'true';
        if (!menuOpen) {
            headerWrap.classList.toggle('hidden', st > lastScroll && st > headerWrap.offsetHeight);
        }
        lastScroll = st;
    });

    // ─── B) Submenu toggle ──────────────────────────────────────────────────────────
    function initSubmenus() {
        const isMobile = window.innerWidth < MOBILE_BREAK;

        document.querySelectorAll('.header-nav li.menu-item-has-children').forEach(li => {
            const btn = li.querySelector('button.submenu-toggle');
            const link = li.querySelector('a.nav-link');

            // verwijder oude listener door te clonen
            if (btn) btn.replaceWith(btn.cloneNode(true));
            const newBtn = li.querySelector('button.submenu-toggle');

            // desktop: hover, geen JS nodig
            if (!isMobile) {
                li.addEventListener('mouseenter', () => li.classList.add('show'));
                li.addEventListener('mouseleave', () => li.classList.remove('show'));
                return;
            }

            // mobiel: klik op chevron
            newBtn.setAttribute('aria-expanded', 'false');
            newBtn.addEventListener('click', e => {
                e.preventDefault();
                const opened = li.classList.toggle('active');
                newBtn.setAttribute('aria-expanded', String(opened));
            });

            // fallback: dummy‑link klapt ook uit
            link.addEventListener('click', e => {
                const href = (link.getAttribute('href') || '').trim();
                if ((!href || href === '#') && isMobile) {
                    e.preventDefault();
                    newBtn.click();
                }
            });
        });
    }

    // init op load én resize
    initSubmenus();
    window.addEventListener('resize', initSubmenus);
});
